import { mapEnumToOptions } from '@abp/ng.core';

export enum ProjectCheckListJoiningOrSignoffCrewVisaType {
  _96Hrs = 0,
  MissionVisa = 1,
  VisitVisa = 2,
  OnArrival = 3,
  Residence = 4,
  MedicalVisa = 5,
}

export const projectCheckListJoiningOrSignoffCrewVisaTypeOptions = mapEnumToOptions(ProjectCheckListJoiningOrSignoffCrewVisaType);
